import React from 'react'
import { Button } from 'reactstrap'
import './DiningMethodButtonGroup.css'

const DiningMethodButtonGroup = ({ value, options, onChange, containerClassName }) => {
    const handleClick = option => {
        onChange(option)
    }

    return (
        <div className={`dining-method-button-group ${containerClassName || ''}`}>
            <h4 className="section-title">Dining Preference</h4>
            <div className="button-group">
                {options.map((option, index) => {
                    const isSelected = value === option.value
                    return (
                        <Button
                            key={index}
                            className={`method-button ${isSelected ? 'selected' : ''}`}
                            onClick={() => handleClick(option)}
                        >
                            {option.label}
                        </Button>
                    )
                })}
            </div>
        </div>
    )
}

export default DiningMethodButtonGroup
